import React from 'react';
import { CFormInput, CButton, CFormSelect, CRow, CCol } from '@coreui/react';
import { CIcon } from '@coreui/icons-react';
import { cilCloudDownload } from '@coreui/icons';
import { getCategoryConfig } from './CategoryConfig';

import SubFilterProgressBar from './DetailComponents/SubFilterProgressBar';

const BuscadorSenales = React.memo(function BuscadorSenales({
  searchInput,
  setSearchInput,
  buscarTexto,
  setBuscarTexto,
  mapFilter,
  activeSubFilter,
  handleSubFilterClick,
  setCurrentPageSenales,
  handleDownload,
  isLoading,
  data,
  priorityFilter,
  setPriorityFilter,
  companyFilter,
  setCompanyFilter
}) {
  // Debounce logic
  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (searchInput !== buscarTexto) {
        setBuscarTexto(searchInput.trim());
        setCurrentPageSenales(1);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchInput, setBuscarTexto, setCurrentPageSenales, buscarTexto]);

  const activeSubs = getCategoryConfig(mapFilter).subFilters || [];

  return (
    <div className="buscador-senales-container">
      <div className="d-flex flex-column gap-3">
        {/* Fila 1: Búsqueda */}
        <CRow className="g-2 align-items-center mx-0">
          <CCol xs={12} sm={5} md={4}>
            <div className="search-input-wrapper">
              <CFormInput
                size="sm"
                placeholder="Buscar por ID, tipo o dirección..."
                className="search-input-custom"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                disabled={isLoading}
              />
            </div>
          </CCol>
          <CCol xs="6" sm="auto">
            <CButton size="sm" className="btn-color px-3 w-100 h-100" disabled={isLoading}
              onClick={() => {
                setBuscarTexto(searchInput.trim());
                setCurrentPageSenales(1);
              }}
            >
              {isLoading ? '...' : 'Buscar'}
            </CButton>
          </CCol>
          <CCol xs="6" sm="auto">
            <CButton size="sm" className="btn-color-secundario px-3 w-100 h-100" disabled={isLoading}
              onClick={() => {
                setSearchInput('');
                setBuscarTexto && setBuscarTexto('');
                setPriorityFilter && setPriorityFilter('all');
                setCompanyFilter && setCompanyFilter('all');
                handleSubFilterClick && handleSubFilterClick(null);
                setCurrentPageSenales(1);
              }}
            >
              Limpiar
            </CButton>
          </CCol>

          {/* Botón Excel */}
          <CCol xs="auto" className="ms-auto">
            <CButton 
              size="sm" 
              className="btn-descargar-list d-flex align-items-center gap-2 px-3" 
              variant="outline" 
              onClick={handleDownload}
              title="Descargar planilla Excel"
            >
              <CIcon icon={cilCloudDownload} />
              <span className="d-none d-md-inline">Descargar Excel</span>
            </CButton>
          </CCol>
        </CRow>

        {/* Fila 2: Empresa y Prioridad (Modular) */}
        {(getCategoryConfig(mapFilter).hasCompany || getCategoryConfig(mapFilter).hasPriority) && (
          <div className="extra-filters-section border-top pt-2">
            <CRow className="g-2 align-items-center mx-0">
              {getCategoryConfig(mapFilter).hasCompany && (
                <CCol xs={12} sm={6} md={4} className="d-flex align-items-center gap-2">
                  <span className="text-secondary small fw-bold text-nowrap" style={{ fontSize: '0.65rem', letterSpacing: '1px' }}>
                    EMPRESA:
                  </span>
                  <CFormSelect 
                    size="sm" 
                    className="flex-grow-1"
                    style={{ fontSize: '0.75rem', borderRadius: '8px' }}
                    value={companyFilter} 
                    onChange={(e) => { setCompanyFilter(e.target.value); setCurrentPageSenales(1); }}
                  >
                    <option value="all">Todas</option>
                    <option value="SANTA ELENA">SANTA ELENA</option>
                    <option value="GRUPO L">GRUPO L</option>
                  </CFormSelect>
                </CCol>
              )}
              {getCategoryConfig(mapFilter).hasPriority && (
                <CCol xs={12} sm={6} md={4} className="d-flex align-items-center gap-2">
                  <span className="text-secondary small fw-bold text-nowrap" style={{ fontSize: '0.65rem', letterSpacing: '1px' }}>
                    PRIORIDAD:
                  </span>
                  <CFormSelect 
                    size="sm" 
                    className="flex-grow-1"
                    style={{ fontSize: '0.75rem', borderRadius: '8px' }}
                    value={priorityFilter} 
                    onChange={(e) => { setPriorityFilter(e.target.value); setCurrentPageSenales(1); }}
                  >
                    <option value="all">Todas</option>
                    <option value="ALTA">Alta</option>
                    <option value="Media">Media</option>
                    <option value="Baja">Baja</option>
                  </CFormSelect>
                </CCol>
              )}
            </CRow>
          </div>
        )}

        {/* Fila 3: Sub-filtros (Solo si hay disponibles) */}
        {activeSubs.length > 0 && (
          <div className="sub-filters-section border-top pt-2">
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <span className="text-secondary small fw-bold text-nowrap" style={{ fontSize: '0.65rem', letterSpacing: '1px' }}>
                SUB-CATEGORÍAS:
              </span>
              <div className="d-flex flex-wrap gap-2">
                {activeSubs.map(sub => (
                  <button
                    key={sub.id}
                    className={`btn-sub-filter-pill ${activeSubFilter === sub.id ? 'active' : ''}`}
                    onClick={() => handleSubFilterClick(sub.id)}
                  >
                    {sub.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Fila 3: Gráfico de Barra (Visualización de distribución) */}
        {['basura', 'arbol', 'sen_horiz'].includes(mapFilter) && (
          <SubFilterProgressBar data={data} mapFilter={mapFilter} />
        )}
      </div>
    </div>

  );
});

export default BuscadorSenales;
